import { default as config } from '../../config.json';
import axios from 'axios';
export const authenticationService = {
  login,
  logout,
  isLoggedIn
}
function isLoggedIn() {
  var isLoggedIn = JSON.parse(localStorage.getItem('currentUser'));
  return !!(isLoggedIn);
}
function login (username:string, password:string) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ username, password })
  };
  return axios.post(config.AUTH_URL, {'username': username, 'password': password })
      .then(res => {
        if(res.data.status == 1) localStorage.setItem('token', res.data.token);
        return res.data;
      })
  /*return fetch(config.AUTH_URL, requestOptions)
      //.then(handleResponse)
      .then(data => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //localStorage.setItem('token', data.json().token);

      });*/
}
function logout() {}
/*
export const authorise = (login: string, password: string): Promise<string> => {
  fetch('/simplicity/tenantauth/login', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      login: login,
      password: password,
    })
  }).then((response) => response.json()).then((json) => {
    return json.token;
  }).catch((error) => {
    console.error(error);
  });
};
*/